<dialog-gala (clickClose)="hideModal()">
    <span gala-dialog-titre>{{ titre }}</span>
    <div>
        <div>
            <div class="div-filtre">
                <div class="row">
                    <div class="col-6">
                        <select-ouinon [label]="lgTrad.PORTEFEUILLE" (selected)="changePortefeuille($event)"
                            bindLabel="label" [selectedItem]="pfClient" [disabled]="!droitsAccess.write"
                            [clearable]="false" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <select-filtre #selectClient [options]="listeClients" (selected)="resetListe()"
                            [label]="translate.instant('CLIENT')" optSorted="ASC" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <select-filtre #selectServices [options]="listeServices" (selected)="changeService()"
                            [label]="translate.instant('APPCLIENT.SERVICES')" optSorted="DESC" />
                    </div>
                    <div class="col-6">
                        <select-filtre #selectServices [options]="listeDocs"
                            (selected)="checkIfDocIsSuiviDesControlesAndResetList()"
                            [label]="translate.instant('DOC')" optSorted="ASC" />
                    </div>
                </div>
                @if (formDates) {
                <form [formGroup]="formDates" autocomplete="off">
                    <div class="row">
                        <div class="col-6">
                            <date-gala formControlName="DDEBUT" (ngModelChange)="resetListe()"
                                [label]="lgTrad.BEGINNINGDATE" />
                        </div>
                        <div class="col-6">
                            <date-gala formControlName="DFIN" (ngModelChange)="resetListe()" [label]="lgTrad.ENDDATE" />
                        </div>
                    </div>
                </form>
                }
            </div>

            <div class="h-1em"></div>

            <div class="justify-content-center align-center text-center">
                <button mat-stroked-button color="primary" (click)="rechercherDocs()">{{lgTrad.RECHERCHER}}</button>
            </div>
        </div>

        @if (hasSearched) {
        <div>
            <div>
                <hr class="divider" />
                <div class="mt-3 container justify-content-center">
                    <table class="table table-striped table-not-rounded">
                        <caption class="caption-sm">
                            <div class="row">
                                <div class="col-md-12">
                                    {{lgTrad.LISTEDOCS}}
                                </div>
                            </div>
                        </caption>
                        <thead>
                            <tr>
                                @for (head of headElements; track head) {
                                <th class="align-middle" [ngClass]="(head.sortable)?'cursor-hand':'cursor-arrow'">
                                    {{head.libelle}}&nbsp;@if (head.sortable) {
                                    <cp-icon-sort [col]="sColTri === head.tri" [boo]="booAscendant" />
                                    }
                                </th>
                                }
                                <th rowspan="3"></th>
                            </tr>
                        </thead>
                        @if (isServiceAutre && isDocumentSdc) {
                        <tr>
                            <td></td>
                            <td> </td>
                            <td> {{ translate.instant("TYPESERVICE.AU") }}</td>
                            <td> {{ translate.instant("SERVICE.SDC") }}</td>
                            <td></td>
                            <td class="col-min">
                                <div class="btn-group">
                                    <ng-container>
                                        @if (droitsAccess.write) {
                                        <gala-btn color="warn" (click)="telechargerSuivi(codeSuiviDesControles)">
                                            <i class="fa fa-download "></i>
                                        </gala-btn>
                                        }
                                    </ng-container>
                                </div>
                            </td>
                        </tr>
                        }
                        @if (isServiceAutre && isDocumentLst) {
                        <tr>
                            <td></td>
                            <td> </td>
                            <td> {{ translate.instant("TYPESERVICE.AU") }}</td>
                            <td> {{ translate.instant("SERVICE.LST") }}</td>
                            <td></td>
                            <td class="col-min">
                                <div class="btn-group">
                                    <ng-container>
                                        @if (droitsAccess.write) {
                                        <gala-btn color="warn" (click)="telechargerSuivi(codeLaitSansTaux)">
                                            <i class="fa fa-download "></i>
                                        </gala-btn>
                                        }
                                    </ng-container>
                                </div>
                            </td>
                        </tr>
                        }
                        <tbody>
                            @for (doc of listeElementsAff; track doc) {
                            <tr>
                                <td>
                                    <menu-client [client]="doc.SERVICE.CLIENT">
                                        {{ doc.SERVICE.CLIENT.NUCHEP }}</menu-client>
                                </td>
                                <td class="wrap">
                                    <menu-client [client]="doc.SERVICE.CLIENT">
                                        {{ doc.SERVICE.CLIENT.NOM }}</menu-client>
                                </td>
                                <td>{{ translate.instant("TYPESERVICE." + doc.SERVICE.TYPESERVICE.CODESERV) }}
                                </td>
                                <td>{{ doc.SERVICE.DOCUMENTS[0].TYPEDOC.LIB }}
                                </td>
                                <td>{{ doc.DATEEVENNEMENT | dateFormat }}</td>
                                <td class="col-min">
                                    <div class="btn-group">
                                        <ng-container>
                                            @if (droitsAccess.write) {
                                            <gala-btn color="warn" (click)="openTelechargement(doc)">
                                                <i class="fa fa-download "></i>
                                            </gala-btn>
                                            }
                                            <gala-btn-search (click)="afficherEnvois(doc)" [disabled]="!doc.BOENVOI" />
                                            @if (droitsAccess.write) {
                                            <gala-btn color="sombre" (click)="openEnvoi(doc)">
                                                <i class="fa fa-envelope"></i>
                                            </gala-btn>
                                            }
                                        </ng-container>
                                    </div>
                                </td>
                            </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        }
        <paginator [invisible]="!hasSearched" [noPadding]="true" />
    </div>
    <div gala-dialog-actions>
        <button mat-stroked-button color="accent" (click)="hideModal()">{{lgTrad.RET}}</button>
    </div>
</dialog-gala>